"use client";
import Image from "next/image";
import { useEffect } from "react";

const Loading = () => {
  useEffect(() => {
    document.body.classList.add("overflow-hidden");

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);
  return (
    <div className="flex items-center justify-center min-h-screen bg-white z-100 fixed top-0 left-0 w-full">
      <Image
        priority
        className="max-w-[180px] md:max-w-[250px] xl:max-w-[300px] w-full h-full animate-pulse"
        src={"/logo/png/sideLogoDark.png"}
        alt="Loading"
        width={300}
        height={40}
      />
      {/* <Image
				className="max-w-[200px] md:max-w-[300px] xl:max-w-[400px] w-full h-full"
				src={"/assets/gif/edvia.gif"}
				alt="Loading"
				width={300}
				height={40}
			/> */}
    </div>
  );
};

export default Loading;
